import React from 'react'
import { FloatingLabel } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';

const CustomDatePicker = ({ id, label, date, onChange }) => {
    return (
        <FloatingLabel
            label={label}
            className="mb-3 date-label"
        >
            <DatePicker
                id={id}
                selected={date}
                dateFormat="dd MMMM yyyy"
                className='date-input date-top-padding'
                onChange={onChange}
                shouldCloseOnSelect
                showYearDropdown
                showMonthDropdown
                dropdownMode="select"
            />
            <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }} />
        </FloatingLabel>
    )
}

CustomDatePicker.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    date: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired
}

export default CustomDatePicker;